<template>
  <div>
    <div
        v-loading="loading"
        class="login">
      <h1>Ring Neighbor Dashboard</h1>
      <a
          :href="`${vars.API_URL}/v2/auth/sign_in`"
          class="el-button el-button--danger">
        Login with Okta
      </a>
    </div>
    <div style="position: absolute; bottom: 20px; width: 100%;">
      <div style="font-size: 12px; text-align: center;">
        Backend: {{ vars.API_URL }} - ENV: {{ vars.NODE_ENV }} -
        Version: {{ vars.VERSION }} ({{ vars.COMMIT }})
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
const { mapActions: authActions, mapGetters: authGetters } = h("auth");
const { mapActions: sharedActions } = h("shared");
export default {
  data() {
    return {
      vars: null,
      loading: false,
    };
  },
  computed: {
    ...authGetters(["user"]),
  },
  created() {
    this.vars = process.env;
    this.checkParams();
  },
  methods: {
    ...authActions(["logIn"]),
    ...sharedActions(["fetchReasons", "fetchMasterData"]),
    checkParams() {
      let token = this.$route.params.token;
      if (token) {
        this.loading = true;
        this.logIn(token)
          .then(() => {
            this.fetchMasterData();
            this.$notify({
              title: "Login success",
              type: "success",
              message: `Welcome ${this.user.email}`,
              position: "top-right",
            });
            this.$router.push({ path: "/" });
          })
          .catch(() => {
            this.$message({ type: "error", message: "Login error" });
          })
          .finally(() => (this.loading = false));
      }
    },
    fetchMasterData() {
      this.$store.dispatch("shared/fetchMasterData", {}, { root: true });
    },
  },
};
</script>

<style lang="scss">
.login {
  text-align: center;
  border: solid 1px #e4e4e4;
  padding: 20px;
  width: 30%;
  margin: 50px auto;
  background: #f4f4f4;
  border-radius: 10px;
}
.login h1 {
  font-weight: 200;
}
.login button {
  color: #fff;
  font-size: 20px;
  padding: 20px 30px;
  font-weight: 300;
}
</style>
